'use client';

import { useAppPathname } from '../../../shared/router/AppRouterContext';
import { useIntl } from 'react-intl';

import ArticlesSectionLink from './ArticlesSectionLink';

type Props = {
  selected: boolean;
  articlesTotalCount: number;
};

export default function ArticlesSectionAllLink({ selected, articlesTotalCount }: Props) {
  const intl = useIntl();
  const pathname = useAppPathname();

  return (
    <ArticlesSectionLink
      href={pathname}
      name={intl.formatMessage({
        defaultMessage: 'Vše',
        id: 'articles.navigation.sections.all',
      })}
      articlesCount={articlesTotalCount}
      isSelected={selected}
    />
  );
}
